import {
  getCanonicalProductColorPath,
  getProductColorPathFromQuery,
  isUnknownProductColorPath
} from '~/utils/colorRoute'

export default defineNuxtRouteMiddleware((to) => {
  if (isUnknownProductColorPath(to.path)) {
    return abortNavigation(createError({
      statusCode: 404,
      statusMessage: 'Page Not Found'
    }))
  }

  const productColorPath = getProductColorPathFromQuery(to.path, to.query.color)
  if (productColorPath) {
    const nextQuery = { ...to.query }
    delete nextQuery.color

    return navigateTo({
      path: productColorPath,
      query: nextQuery,
      hash: to.hash || ''
    }, { redirectCode: 301 })
  }

  const canonicalPath = getCanonicalProductColorPath(to.path)
  if (!canonicalPath) return

  return navigateTo({
    path: canonicalPath,
    query: to.query,
    hash: to.hash || ''
  }, { redirectCode: 301 })
})
